import { Component } from '@angular/core';

@Component({
  selector: 'app-tile-messages',
  templateUrl: './tile-messages.component.html',
  styleUrls: ['./tile-messages.component.scss']
})
export class TileMessagesComponent {

}
